import { render, staticRenderFns } from "./NewsManage.vue?vue&type=template&id=06c7d797&scoped=true"
import script from "./NewsManage.vue?vue&type=script&lang=js"
export * from "./NewsManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c7d797",
  null
  
)

export default component.exports